<template>
	<page>
		<module enable-flex>
			<m-operate>
				<c-button color="main" v-if="auth('b_mall_banner_edit')" prepend-icon="tf-add" @click="$refs.bannerEdit.open()">添加Banner</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="false">

				<c-table-column
					label="标题"
					name="title"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="Banner图片"
					name="image_url"
					width="160"
					fixed="left"
				>
					<template #default="{data}">
						<c-file v-if="data.image_url" class="image" :src="data.image_url" media style="width:120px;height:60px;object-fit:cover;"></c-file>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="客户端类型"
					name="type"
					width="110"
				>
					<template #default="{data}">
						<c-state tag async dict="AD_TYPE" :value="data.type"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="本地地址"
					name="local_url"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.local_url" class="ellipsis" :title="data.link_url">{{ data.local_url }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="跳转地址"
					name="link_url"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.link_url" class="ellipsis" :title="data.link_url">{{ data.link_url }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="小程序APPID"
					name="jump_app_id"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.jump_app_id">{{ data.jump_app_id }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="排序"
					name="sort_no"
					type="sort"
					fixed="right"
					@handle="sortHandle">
					>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="100"
					fixed="right"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_mall_banner_state')" v-model="data.state" :state-value="[1, 2]"
							:state-text="['启用','禁用']"
							@beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="145"
					button-limit="6"
					fixed="right"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_mall_banner_edit')" icon="tf-edit" @click="$refs.bannerEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_mall_banner_del')" icon="tf-trash" color="red" @click="removeBanner(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--新增/编辑Banner弹窗-->
			<banner-edit ref="bannerEdit" @resolve="$refs.list.update()"></banner-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import bannerEdit from "@/pages/mall/banner_edit.vue";

	export default {
		components: {
			bannerEdit,
		},
		computed: {
			...mapState(['disableEnableDic'])
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********客户端类型格式化************/
			formatType(type) {
				const map = {1: '通用', 2: 'App', 3: '靓机小程序', 4: '报价小程序'};
				return map[type] || '-';
			},

			/********跳转方式格式化************/
			formatLinkType(linkType) {
				const map = {1: '无跳转', 2: '外部链接', 3: '内部页面', 4: '第三方小程序'};
				return map[linkType] || '-';
			},

			/********搜索************/
			searchHandle(data) {
				if (!data) {
					data = {};
				}
				this.$refs.list.load({
					url: '/mall/banner/list',
					data
				});
			},

			/******启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/mall/banner/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					loading: true,
					success: () => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						next();
					}
				});
			},

			/******删除Banner**********/
			removeBanner(data) {
				this.$confirm({
					message: '确认删除Banner【' + data.title + '】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/banner/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: data => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},
					cancel: () => {},
				});
			},
			sortHandle(row, type, next) {
				this.request({
					url: '/mall/banner/sort',
					data: {
						id: row.data.id,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
                        // next();
                        this.$refs.list.update();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
